import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

import { AxiomLogo } from '../AxiomLogo/AxiomLogo';
import { Gutter } from '../../layout/Gutter/Gutter';

export const LoaderLogo = () => (
  <div className="axiom-loader-logo">
    <Dimmer active>
      <Gutter bottom="56px" horizontal="auto">
        <AxiomLogo />
      </Gutter>
      <div className="loader-container">
        <Loader indeterminate size="massive" />
      </div>
    </Dimmer>
  </div>
);
